{
  "categories": {
    "certificates": "Sertifikalar",
    "dashboard": "Kontrol Paneli",
    "dataTransfer": "Veri Transferi",
    "other": "Diğer",
    "products": "Ürünler",
    "suppliers": "Tedarikçiler"
  },
  "title": "SSS"
}
